export enum MapIconColor {
	streetAsset = "#FF8139",
	greenfield = "#02BB41",
	rooftop = "#5E8DFF",
	option = "#808080",
	tower = "#C33149",
}
